
import { Vue, Component } from 'vue-property-decorator'
import ToolbarComponent from '@/components/global/ToolbarComponent.vue'
import ClientSubscriptionComponent from '@/components/subscription/ClientSubscriptionComponent.vue'

@Component({
    components: { ClientSubscriptionComponent, ToolbarComponent },
})
export default class SubscriptionPage extends Vue {
    tab_selected = 'subscription-tab'
}
